/**
 * Mounts the Cuidari MUI theme for the whole app.
 *
 * - `StyledEngineProvider injectFirst` puts emotion/MUI styles at the TOP of
 *   <head> so Tailwind utility classes (loaded after) still win on shared
 *   elements — we opt into MUI styling via the theme + `sx`, not by accident.
 * - We deliberately do NOT render `<CssBaseline/>`: the app already ships a
 *   Tailwind + Metronic global reset and CssBaseline would fight it.
 */
import type { ReactNode } from 'react'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { cuidariMuiTheme } from './theme'

export function CuidariMuiProvider({ children }: { children: ReactNode }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={cuidariMuiTheme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  )
}
